/*
 * LITIO.STORE — menu overlay ottimizzato
 * I dettagli categoria vengono istanziati solo al primo utilizzo.
 * 31-08-2026
 */
(function () {
  if (customElements.get('litio-menu-overlay')) return;

  class LitioMenuOverlay extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.litio-menu-trigger');
      this.panel = this.querySelector('.litio-menu-overlay__panel');
      this.closeBtn = this.querySelector('.litio-menu-overlay__close');
      this.grid = this.querySelector('.litio-menu-overlay__grid');
      this.details = Array.prototype.slice.call(this.querySelectorAll('.litio-menu-detail'));
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.litio-menu-card'));
      if (!this.trigger || !this.panel || !this.closeBtn) return;

      this.trigger.addEventListener('click', this.open.bind(this));
      this.closeBtn.addEventListener('click', this.close.bind(this));
      this.panel.addEventListener('click', (event) => {
        const toggle = event.target.closest('.litio-menu-level2-card__title--toggle, button.litio-product-preview--second');
        if (!toggle) return;
        const card = toggle.closest('.litio-menu-level2-card');
        const children = card && card.querySelector('.litio-menu-level2-card__children');
        if (!children) return;
        const opening = children.hidden;
        children.hidden = !opening;
        card.querySelectorAll('.litio-menu-level2-card__title--toggle, button.litio-product-preview--second').forEach((control) => {
          control.setAttribute('aria-expanded', opening ? 'true' : 'false');
        });
      });

      this.cards.forEach((card) => {
        const targetId = card.getAttribute('data-target');
        const prepare = () => {
          const detail = this.getDetail(targetId);
          if (detail) this.hydrateDetail(detail);
        };
        card.addEventListener('pointerenter', prepare, { passive: true });
        card.addEventListener('focus', prepare, { passive: true });
        card.addEventListener('click', () => this.showDetail(targetId));
      });

      this.panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    getDetail(targetId) {
      if (!targetId) return null;
      return this.querySelector('#' + CSS.escape(targetId));
    }

    hydrateDetail(detail) {
      if (!detail || detail.dataset.hydrated === 'true') return;
      const template = detail.querySelector('.litio-menu-detail__template');
      if (!template) return;
      detail.appendChild(template.content.cloneNode(true));
      template.remove();
      detail.dataset.hydrated = 'true';
    }

    warmImages(scope) {
      if (!scope) return;
      scope.querySelectorAll('.litio-product-preview img').forEach((img) => {
        img.loading = 'lazy';
        img.fetchPriority = 'low';
      });
    }

    open() {
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('litio-menu-is-open');
      this.showGrid();
      this.warmImages(this.grid);
      window.requestAnimationFrame(() => this.closeBtn.focus());
    }

    close() {
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('litio-menu-is-open');
      this.trigger.focus();
    }

    showDetail(targetId) {
      const activeDetail = this.getDetail(targetId);
      if (!activeDetail) return;
      this.hydrateDetail(activeDetail);
      this.warmImages(activeDetail);
      this.grid.hidden = false;
      this.details.forEach((detail) => {
        detail.hidden = detail !== activeDetail;
      });
      this.cards.forEach((card) => card.setAttribute('aria-expanded', card.getAttribute('data-target') === targetId ? 'true' : 'false'));
      window.requestAnimationFrame(() => activeDetail.scrollIntoView({ block: 'start', behavior: 'smooth' }));
    }

    showGrid() {
      this.grid.hidden = false;
      this.details.forEach((detail) => {
        detail.hidden = true;
      });
      this.cards.forEach((card) => card.setAttribute('aria-expanded', 'false'));
      this.panel.scrollTo({ top: 0, behavior: 'auto' });
    }
  }

  customElements.define('litio-menu-overlay', LitioMenuOverlay);
})();

/* Litio Store — audit link interni 12-09-2026.
 * Rimuove dalle pagine-indice le voci eliminate dal catalogo, corregge il
 * vecchio typo Microinverter e sopprime CTA senza una destinazione valida.
 * I vecchi URL restano coperti dai redirect Shopify per SEO/segnalibri.
 */
document.addEventListener('DOMContentLoaded', function () {
  const obsoletePaths = new Set([
    '/collections/catalogo-batterie-tecnologia-lto-litio-titanato-19m0n1y',
    '/collections/catalogo-batterie-tecnologia-supercondensatori-1u5d65a',
    '/collections/catalogo-batterie-formato-batterie-in-box-9mvtrb',
    '/collections/catalogo-kit-fotovoltaici-kit-microinverter-e-da-balcone-batteria-per-impianti-esistenti-1jj9xjq',
    '/collections/catalogo-kit-fotovoltaici-kit-casa-backup-e-emergenza-e8504y',
    '/collections/catalogo-kit-fotovoltaici-kit-camper-barca-kit-power-station-pannelli-bva12x',
    '/collections/catalogo-fotovoltaico-accessori-fotovoltaico-quadri-vuoti-12kmo1y',
    '/collections/catalogo-inverter-ac-coupled-retrofit-1psnpas',
    '/collections/catalogo-ricarica-caricabatterie-da-rete-230v-96v-1q4bh4b',
    '/collections/catalogo-ricarica-ricarica-da-alternatore-48v-48v-11mpp2w',
    '/collections/catalogo-ricarica-ricarica-solare-accessori-regolatori-qex5nd',
    '/collections/catalogo-accessori-connessioni-e-protezioni-capocorda-1ens3hz',
    '/collections/catalogo-victron-energy-caricabatterie-blue-smart-ip43-1k3r7ik',
    '/collections/catalogo-victron-energy-cavi-solari-e-accessori-1o70ad3',
    '/collections/catalogo-victron-energy-batterie-lifepo4-1qtlfd',
    '/collections/catalogo-victron-energy-isolatori-e-trasformatori-181csiq',
    '/collections/catalogo-victron-energy-ev-charging-station-12hrive',
    '/collections/catalogo-victron-energy-ats-3eqfmm',
    '/collections/catalogo-victron-energy-gmdsspanel-and-tank-senders-1ul3rj5'
  ]);

  const replacements = {
    '/collections/catalogo-kit-fotovoltaici-kit-microinverter-e-da-balcone-kit-microinverrter-8gxf0r':
      '/collections/catalogo-kit-fotovoltaici-kit-microinverter-e-da-balcone-kit-microinverter-8gxf0r'
  };

  document.querySelectorAll('a[href]').forEach(function (link) {
    let path;
    try {
      path = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/$/, '');
    } catch (error) {
      return;
    }

    if (replacements[path]) {
      link.setAttribute('href', replacements[path]);
      return;
    }

    if (!obsoletePaths.has(path)) return;

    const listItem = link.closest('li');
    if (listItem && listItem.closest('.litio-category-card')) {
      listItem.remove();
      return;
    }

    const card = link.closest('article.litio-category-card');
    if (card) {
      card.remove();
      return;
    }

    link.remove();
  });

  /* La vecchia pagina "La Banda del Litio" non esiste più e il redirect
     storico porta alla home: il CTA sarebbe quindi fuorviante. */
  document.querySelectorAll('a[href*="/pages/la-banda-del-litio"]').forEach(function (link) {
    link.remove();
  });

  /* Nel configuratore era rimasta una voce 24/24-17A "Isolated" che usava
     l'URL del modello Non-isolated. Il modello isolato non è più a catalogo. */
  if (window.location.pathname.replace(/\/$/, '') === '/pages/calcolatrice-dc-dc-charger') {
    try {
      if (Array.isArray(products)) {
        for (let i = products.length - 1; i >= 0; i -= 1) {
          if (String(products[i].title || '').includes('24/24-17A Isolated')) {
            products.splice(i, 1);
          }
        }
      }
    } catch (error) {
      /* Nessuna modifica se la pagina cambia struttura in futuro. */
    }
  }
});
